import { Component } from '@angular/core';
import { pageData } from '../report-routing.module';
import { ProductReportService } from './product-report.service';
import { map, Observable, shareReplay } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { Constants } from "@dealpos-npm/ng-dealpos-library/constants";

@Component({
    selector: 'app-product-report',
    templateUrl: './product-report.component.html',
    styleUrls: ['./product-report.component.scss'],
    standalone: false
})
export class ProductReportComponent {
  public pageData = pageData;
  public productList$: Observable<any>;
  private originalData$: Observable<any>;

  constructor(private productReportService: ProductReportService) {
    this.loadProductList();
  }

  private loadProductList() {
    this.originalData$ = this.productReportService.getProductList().pipe(shareReplay(1));
    this.productList$ = this.originalData$;
  }

  public sortData(sort: Sort) {
    if (!sort.active || sort.direction === "") {
      // Reset to original data when no sort is applied
      this.productList$ = this.originalData$;
      return;
    }

    this.productList$ = this.originalData$.pipe(
      map(data => {
        return [...data].sort((a: any, b: any) => {
          return Constants.compare(a[sort.active], b[sort.active], sort.direction === "asc");
        });
      })
    );
  }
}
